import React from 'react'
import { Typography } from 'antd'

const CustomTextColumn = ({ text, isStrong = false }) => {

  return (
    <div className={'centered-div'}>
      <Typography.Title level={5}>
        {isStrong ? (
          <strong>{text}</strong>
        ) : (
          <>{text}</>
        )}
      </Typography.Title>
    </div>
  )
}

export default CustomTextColumn
